import { LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface ServiceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  link: string;
}

export const ServiceCard = ({ title, description, icon: Icon, link }: ServiceCardProps) => {
  console.log('Rendering ServiceCard:', { title, link });
  
  return (
    <Card className="overflow-hidden transition-all hover:shadow-lg">
      <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
        <div className="p-3 bg-primary/10 rounded-full">
          <Icon className="h-8 w-8 text-primary" />
        </div>
        <h3 className="text-xl font-semibold">{title}</h3>
        <p className="text-muted-foreground">{description}</p>
        <Button asChild className="mt-4">
          <Link to={link}>Learn More</Link>
        </Button>
      </CardContent>
    </Card>
  );
};